<script src="plant-setup-details.component.spec.ts"></script>
<div class="container user-management-page">
  <mic-breadcrumb id="finished-product-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/setup/plantSetup" label="{{ translationService.translate('plantSetupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('plantSetupDetailsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>
  @if (plantSetupDetails) {
  <form [formGroup]="plantForm">
    <div class="flex items-center justify-between mt-3 mb-4">
      <h2 class="page-title m-0" id="plant-setup-heading">
        {{ translationService.translate('plantSetupDetailsText') }}
      </h2>
      <div class="action-buttons">
        <button
          id="add-button"
          type="button"
          mat-flat-button
          color="primary"
          class="btn-primary"
          (click)="save()"
          [matTooltip]="productSaveDisabled ? this.translationService.translate('comingSoonText') : null"
          [disabled]="productSaveDisabled"
        >
          <mat-icon>save</mat-icon> {{ translationService.translate('saveLinkText') }}
        </button>
        <button id="cancel-button" type="button" mat-flat-button class="btn-cancel" (click)="cancel()">
          <mat-icon>cancel</mat-icon> {{ translationService.translate('cancelText') }}
        </button>
      </div>
    </div>
    <!-- Use plantForm.get('plantSetupDetails') for plant setup details -->
    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="folder"></mic-icon>
            {{ translationService.translate('genericInformationText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="grid grid-rows-4 mt-3" [formGroup]="plantSetupDetails">
          <div class="grid grid-cols-4 gap-5 items-center">
            <mat-form-field appearance="fill" id="mat_code" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('codeText') }}</mat-label>
              <input id="code" matInput type="text" [formControlName]="'code'" maxlength="3" />
              @if (plantSetupDetails.get('code')?.hasError('required')) {
              <mat-error>
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
              } @else if (plantSetupDetails.get('code')?.hasError('duplicateCode')) {
              <mat-error>
                {{ translationService.translate('codeExistsText') }}
              </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_name" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('nameText') }}</mat-label>
              <input id="name" matInput type="text" [formControlName]="'name'" maxlength="50" />
              @if (plantSetupDetails.get('name')?.hasError('required')) {
              <mat-error>
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
              } @else if (plantSetupDetails.get('name')?.hasError('duplicateName')) {
              <mat-error>
                {{ translationService.translate('nameExistsText') }}
              </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_contactName" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('contactText') }}</mat-label>
              <input id="contactName" matInput type="text" [formControlName]="'contactName'" maxlength="25" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_emailAdress" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('emailAddressText') }}</mat-label>
              <input id="emailAdress" matInput type="email" [formControlName]="'emailAdress'" maxlength="35" />
              @if (plantSetupDetails.get("emailAdress")?.hasError("email") && plantSetupDetails.get("emailAdress")?.touched) {
              <mat-error>{{ translationService.translate('invalidEmailText') }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="grid grid-cols-4 gap-5 items-center mt-2">
            <mat-form-field appearance="fill" id="mat_phoneNumber" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('phoneNumberText') }}</mat-label>
              <input id="phoneNumber" matInput type="text" [formControlName]="'phoneNumber'" maxlength="20" />
              @if (plantSetupDetails.get('phoneNumber')?.hasError('invalidPhone') && plantSetupDetails.get('phoneNumber')?.touched) {
              <mat-error>
                {{ translationService.translate('invalidPhoneNumberText') }}
              </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_faxNumber" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('faxNumberText') }}</mat-label>
              <input id="faxNumber" matInput type="text" [formControlName]="'faxNumber'" maxlength="20" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_addressOne" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('addr1Text') }}</mat-label>
              <input id="addressOne" matInput type="text" [formControlName]="'addressOne'" maxlength="35" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_addressTwo" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('addr2Text') }}</mat-label>
              <input id="addressTwo" matInput type="text" [formControlName]="'addressTwo'" maxlength="35" />
            </mat-form-field>
          </div>
          <div class="grid grid-cols-4 gap-5 items-center mt-2">
            <mat-form-field appearance="fill" id="mat_city" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('cityText') }}</mat-label>
              <input id="city" matInput type="text" [formControlName]="'city'" maxlength="20" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_stateProvince" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('stateText') }}</mat-label>
              <input id="stateProvince" matInput type="text" [formControlName]="'stateProvince'" maxlength="20" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="countryCode" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('customerCountryText') }}</mat-label>
              <mat-select type="text" [formControlName]="'countryCode'">
                @for (option of countries; track option) {
                <mat-option [value]="option"> {{ option }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_postalCode" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('customerPostalCodeText') }}</mat-label>
              <input id="postalCode" matInput type="text" [formControlName]="'postalCode'" maxlength="20" />
            </mat-form-field>
          </div>
          <div class="grid grid-cols-4 gap-5 items-center mt-2">
            <div>
              <mat-label class="custom-label-error pr-5">{{ translationService.translate('activeText') }}</mat-label>
              <mat-slide-toggle id="plant-active-switch" [formControlName]="'plantActive'" title="Yes">
                {{ translationService.translate(plantSetupDetails.get('plantActive').value ? 'yesText' : 'noText') }}
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="settings"></mic-icon>
            {{ translationService.translate('settingsText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="grid grid-rows-3 mt-3" [formGroup]="plantSetupDetails">
          <div class="grid grid-cols-4 gap-5 items-center">
            <mat-form-field appearance="fill" id="mat_plantType" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('plantTypeText') }}</mat-label>
              <mat-select id="plantType" [formControlName]="'plantType'">
                @for (type of plantTypes; track type) {
                <mat-option [value]="type.toUpperCase()">{{ type }}</mat-option>
                }
              </mat-select>
              @if (plantSetupDetails.get('plantType')?.hasError('required')) {
              <mat-error>
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
              }
            </mat-form-field>
            <div class="mt-0 pt-0">
              <mic-dropdown-search
                micDropdownAccessibility
                appearance="fill"
                [formControlName]="'timezoneFk'"
                [data]="timeZoneLabels"
                [multiple]="false"
                [widthConfig]="{ width: '100%' }"
                [formGroup]="plantSetupDetails"
                label="{{ translationService.translate('timeZoneText') }}"
              />
            </div>
            <mat-form-field appearance="fill" id="mat_plantNumber" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('plantNumberText') }}</mat-label>
              <input id="plantNumber" matInput type="text" [formControlName]="'plantNumber'" maxlength="2" />
              @if (plantSetupDetails.get("plantNumber")?.hasError("required")) {
              <mat-error>{{ translationService.translate('thisIsMandatoryFieldText') }}</mat-error>
              } @else if (plantSetupDetails.get("plantNumber")?.hasError("pattern")) {
              <mat-error>{{ translationService.translate('plantNumberValidationText') }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_installDt" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('installDateText') }}</mat-label>
              <input id="installDt" matInput type="text" [matDatepicker]="picker" [formControlName]="'installDt'" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="grid grid-cols-4 gap-5 items-center mt-2">
            <mat-form-field appearance="fill" id="mat_interfaceId1" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('interfaceID1LabelText') }}</mat-label>
              <input id="interfaceId1" matInput type="text" [formControlName]="'interfaceId1'" maxlength="10" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_interfaceId2" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('interfaceID2LabelText') }}</mat-label>
              <input id="interfaceId2" matInput type="text" [formControlName]="'interfaceId2'" maxlength="10" />
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_michelinShipToNumber" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('michelinShipToNumberText') }}</mat-label>
              <input id="michelinShipToNumber" matInput type="text" [formControlName]="'michelinShipToNumber'" maxlength="10" />
              @if (plantSetupDetails.get("michelinShipToNumber")?.hasError("required")) {
              <mat-error>{{ translationService.translate('thisIsMandatoryFieldText') }}</mat-error>
              } @else if (plantSetupDetails.get("michelinShipToNumber")?.hasError("pattern")) {
              <mat-error>{{ translationService.translate('shipToNumberValidationText') }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="fill" id="mat_woCompleteStartTime" class="col-span-1 w-full readonly-field">
              <mat-label class="custom-label-error">{{ translationService.translate('woCompleteProcessRunsAtText') }}</mat-label>
              <input
                id="woCompleteStartTime"
                readonly
                matInput
                type="text"
                [matTimepicker]="minutesPicker"
                [formControlName]="'woCompleteStartTime'"
              />
              <mat-timepicker-toggle matIconSuffix [for]="minutesPicker" />
              <mat-timepicker interval="5min" #minutesPicker />
              @if (plantSetupDetails.get("woCompleteStartTime")?.hasError("required")) {
              <mat-error>{{ translationService.translate('thisIsMandatoryFieldText') }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="grid grid-cols-4 gap-5 items-center mt-2">
            <mat-form-field appearance="fill" id="mat_dueDtElapsedTime" class="col-span-1 w-full">
              <mat-label class="custom-label-error">{{ translationService.translate('dueDateElapsedTimeText') }}</mat-label>
              <input
                id="dueDtElapsedTime"
                matInput
                type="text"
                inputmode="numeric"
                [formControlName]="'dueDtElapsedTime'"
                maxlength="3"
                (input)="onNumericInput($event)"
              />
              @if (plantSetupDetails.get('dueDtElapsedTime')?.hasError('required')) {
              <mat-error>
                {{ translationService.translate('thisIsMandatoryFieldText') }}
              </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="settings"></mic-icon>
            {{ translationService.translate('workflowConfigurationText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <!-- Add workflow configuration fields here -->
        <div class="grid grid-rows-8 mt-3" [formGroup]="plantSetupDetails">
          <div class="grid grid-cols-6 items-center mt-2">
            <p id="req-td-initial" class="pr-5 w-full">
              {{ translationService.translate('requireTreadDepthEntryAtInitialInspectionText') }}
            </p>
            <mat-slide-toggle id="req-td-initial-switch" [formControlName]="'reqTdInitial'">
              {{ translationService.translate(plantSetupDetails.get('reqTdInitial').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="auto-inc-barcode" class="pr-5">{{ translationService.translate('autoIncrementBarcodeText') }}</p>
            <mat-slide-toggle id="auto-inc-barcode-switch" [formControlName]="'autoIncBarcode'">
              {{ translationService.translate(plantSetupDetails.get('autoIncBarcode').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="enable-csd-report" class="pr-5">{{ translationService.translate('centralReportingEnableText') }}</p>
            <mat-slide-toggle id="enable-csd-report-switch" [formControlName]="'enableCsdReport'">
              {{ translationService.translate(plantSetupDetails.get('enableCsdReport').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
          </div>
          <div class="grid grid-cols-6 gap-1 items-center">
            <p id="ck-cam-spec-wo" class="pr-5">{{ translationService.translate('checkCamSpecsAtWoEntryText') }}</p>
            <mat-slide-toggle id="ck-cam-spec-wo-switch" [formControlName]="'ckCamSpecWo'">
              {{ translationService.translate(plantSetupDetails.get('ckCamSpecWo').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="disbl-rjct-lbl-dis" class="pr-5">{{ translationService.translate('disableRejectLabelsForDisposedText') }}</p>
            <mat-slide-toggle id="disbl-rjct-lbl-dis-switch" [formControlName]="'disblRjctLblDis'">
              {{ translationService.translate(plantSetupDetails.get('disblRjctLblDis').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="filter-bias-sizes" class="pr-5">{{ translationService.translate('filterOutBiasCasingSizesText') }}</p>
            <mat-slide-toggle id="filter-bias-sizes-switch" [formControlName]="'filterBiasSizes'">
              {{ translationService.translate(plantSetupDetails.get('filterBiasSizes').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
          </div>
          <div class="grid grid-cols-6 gap-1 items-center mt-2">
            <p id="ck-cam-spec-wo-shopfloor" class="pr-5">
              {{ translationService.translate('camsIgnoredOnWoEntryIgnoredOnShopFloorText') }}
            </p>
            <mat-slide-toggle id="ck-cam-spec-wo-shopfloor-switch" [formControlName]="'ckCamSpecWoShopfloor'">
              {{ translationService.translate(plantSetupDetails.get('ckCamSpecWoShopfloor').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="disbl-rjct-lbl-ret" class="pr-5">{{ translationService.translate('disableRejectLabelsForReturnedText') }}</p>
            <mat-slide-toggle id="disbl-rjct-lbl-ret-switch" [formControlName]="'disblRjctLblRet'">
              {{ translationService.translate(plantSetupDetails.get('disblRjctLblRet').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="automatic-remaining-tread-depth" class="pr-5">{{ translationService.translate('automaticTreadDepthText') }}</p>
            <mat-slide-toggle id="automatic-remaining-tread-depth-switch" [formControlName]="'automaticRemainingTreadDepth'">
              {{ translationService.translate(plantSetupDetails.get('automaticRemainingTreadDepth').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
          </div>
          <div class="grid grid-cols-6 gap-1 items-center mt-2">
            <p id="allow-due-date-we" class="pr-5">{{ translationService.translate('allowDueDateOnWeekendText') }}</p>
            <mat-slide-toggle id="allow-due-date-we-switch" [formControlName]="'allowDueDateWe'">
              {{ translationService.translate(plantSetupDetails.get('allowDueDateWe').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="manage-inventory" class="pr-5">{{ translationService.translate('manageInventoryInBibTreadNextText') }}</p>
            <mat-slide-toggle id="manage-inventory-switch" [formControlName]="'manageInventory'">
              {{ translationService.translate(plantSetupDetails.get('manageInventory').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="received-dt-editable" class="pr-5">{{ translationService.translate('receivedDateEditingText') }}</p>
            <mat-slide-toggle id="received-dt-editable-switch" [formControlName]="'receivedDtEditable'">
              {{ translationService.translate(plantSetupDetails.get('receivedDtEditable').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
          </div>
          <div class="grid grid-cols-6 gap-1 items-center mt-2">
            <p id="force-reject-by-casing" class="pr-5">{{ translationService.translate('forceRejectsThroughRejectByCasingPostText') }}</p>
            <mat-slide-toggle id="force-reject-by-casing-switch" [formControlName]="'forceRejectByCasing'">
              {{ translationService.translate(plantSetupDetails.get('forceRejectByCasing').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="received-dt-previous-day" class="pr-5">{{ translationService.translate('setReceivedDateToPreviousDayText') }}</p>
            <mat-slide-toggle id="received-dt-previous-day-switch" [formControlName]="'receivedDtPreviousDay'">
              {{ translationService.translate(plantSetupDetails.get('receivedDtPreviousDay').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="include-scrap-casings-reject-casing" class="pr-5">
              {{ translationService.translate('includeScrapCasingsInRejectByCasingPostText') }}
            </p>
            <mat-slide-toggle id="include-scrap-casings-reject-casing-switch" [formControlName]="'includeScrapCasingsRejectCasing'">
              {{ translationService.translate(plantSetupDetails.get('includeScrapCasingsRejectCasing').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
          </div>
          <div class="grid grid-cols-6 gap-1 items-center mt-2">
            <p id="engraving-integration" class="pr-5">{{ translationService.translate('engravingIntegrationText') }}</p>
            <mat-slide-toggle id="engraving-integration-switch" [formControlName]="'engravingIntegration'">
              {{ translationService.translate(plantSetupDetails.get('engravingIntegration').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="req-barcode-entry" class="pr-5">{{ translationService.translate('requireBarCodeEntryText') }}</p>
            <mat-slide-toggle id="req-barcode-entry-switch" [formControlName]="'reqBarcodeEntry'">
              {{ translationService.translate(plantSetupDetails.get('reqBarcodeEntry').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="remember-fields-on-add-line" class="pr-5">{{ translationService.translate('rememberFieldsOnAddLineText') }}</p>
            <mat-slide-toggle id="remember-fields-on-add-line-switch" [formControlName]="'rememberFieldsOnAddLine'">
              {{ translationService.translate(plantSetupDetails.get('rememberFieldsOnAddLine').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
          </div>
          <div class="grid grid-cols-6 gap-1 items-center mt-2">
            <p id="allow-plant-plant-transfer" class="pr-5">{{ translationService.translate('allowPlantToPlantTransferText') }}</p>
            <mat-slide-toggle id="allow-plant-plant-transfer-switch" [formControlName]="'allowPlantPlantTransfer'">
              {{ translationService.translate(plantSetupDetails.get('allowPlantPlantTransfer').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="allow-misc-charges" class="pr-5">{{ translationService.translate('allowMiscellaneousChargesText') }}</p>
            <mat-slide-toggle id="allow-misc-charges-switch" [formControlName]="'allowMiscCharges'">
              {{ translationService.translate(plantSetupDetails.get('allowMiscCharges').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
            <p id="scrap-shipping" class="pr-5">{{ translationService.translate('scrapShippingText') }}</p>
            <mat-slide-toggle id="scrap-shipping-switch" [formControlName]="'scrapShipping'">
              {{ translationService.translate(plantSetupDetails.get('scrapShipping').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
          </div>
          <div class="grid grid-cols-6 gap-1 items-center mt-2">
            <p id="capture-xray-res" class="pr-5">{{ translationService.translate('captureXRayResultText') }}</p>
            <mat-slide-toggle id="capture-xray-res-switch" [formControlName]="'captureXRayRes'">
              {{ translationService.translate(plantSetupDetails.get('captureXRayRes').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="settings"></mic-icon>
            {{ translationService.translate('rfidSettingsText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="grid grid-cols-6 gap-1 items-center mt-2" [formGroup]="plantSetupDetails">
          <p id="rfid-enabled" class="pr-5">{{ translationService.translate('rfidEnabledText') }}</p>
          <mat-slide-toggle id="rfid-enabled-switch" [formControlName]="'rfidEnabledFlag'">
            {{ translationService.translate(plantSetupDetails.get('rfidEnabledFlag').value ? 'yesText' : 'noText') }}
          </mat-slide-toggle>
        </div>

        <!-- Additional RFID settings that appear when RFID is enabled -->
        @if (plantSetupDetails.get('rfidEnabledFlag').value) {
        <h4 class="mt-4 mb-2 font-medium ml-2">
          <b>{{ translationService.translate('initialText') }}</b>
        </h4>
        <div class="grid grid-cols-6 gap-5 items-center mt-2 ml-2" [formGroup]="plantSetupDetails">
          <div class="grid grid-cols-2 gap-5 items-center col-span-2">
            <p id="rfid-timer" class="pr-5">{{ translationService.translate('rfidReadTimeText') }}</p>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ translationService.translate('inSecondsText') }}</mat-label>
              <input id="rfid-timer-input" matInput type="number" [formControlName]="'rfidTimer'" />
            </mat-form-field>
          </div>

          <div class="grid grid-cols-2 gap-5 items-center col-span-2">
            <p id="rfid-auto-read-initial" class="pr-5">{{ translationService.translate('rfidAutomaticReadText') }}</p>
            <mat-slide-toggle id="rfid-auto-read-initial-switch" [formControlName]="'rfidAutoReadInitial'">
              {{ translationService.translate(plantSetupDetails.get('rfidAutoReadInitial').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
          </div>
        </div>

        <h4 class="mt-4 mb-2 font-medium ml-2">
          <b>{{ translationService.translate('finalText') }}</b>
        </h4>
        <div class="grid grid-cols-6 gap-5 items-center mt-2 ml-2" [formGroup]="plantSetupDetails">
          <div class="grid grid-cols-2 gap-5 items-center col-span-2">
            <p id="rfid-read-time-final" class="pr-5">{{ translationService.translate('rfidReadTimeText') }}</p>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ translationService.translate('inSecondsText') }}</mat-label>
              <input id="rfid-read-time-final-input" matInput type="number" [formControlName]="'rfidReadTimerFinal'" />
            </mat-form-field>
          </div>

          <div class="grid grid-cols-2 gap-5 items-center col-span-2">
            <p id="rfid-write-time-final" class="pr-5">{{ translationService.translate('rfidWriteTimeText') }}</p>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ translationService.translate('inSecondsText') }}</mat-label>
              <input id="rfid-write-time-final-input" matInput type="number" [formControlName]="'rfidWriteTimerFinal'" />
            </mat-form-field>
          </div>

          <div class="grid grid-cols-2 gap-5 items-center col-span-2">
            <p id="rfid-write-attempt-final" class="pr-5">{{ translationService.translate('rfidWriteAttemptsText') }}</p>
            <mat-form-field appearance="fill" class="w-full">
              <input id="rfid-write-attempt-final-input" matInput type="number" [formControlName]="'rfidWriteAttemptFinal'" />
            </mat-form-field>
          </div>
        </div>

        <div class="grid grid-cols-6 gap-5 items-center mt-2 ml-2" [formGroup]="plantSetupDetails">
          <div class="grid grid-cols-2 gap-5 items-center col-span-2">
            <p id="rfid-lock-time-final" class="pr-5">{{ translationService.translate('rfidLockTimeText') }}</p>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>{{ translationService.translate('inSecondsText') }}</mat-label>
              <input id="rfid-lock-time-final-input" matInput type="number" [formControlName]="'rfidLockTimerFinal'" />
            </mat-form-field>
          </div>

          <div class="grid grid-cols-2 gap-5 items-center col-span-2">
            <p id="rfid-lock-attempt-final" class="pr-5">{{ translationService.translate('rfidLockAttemptsText') }}</p>
            <mat-form-field appearance="fill" class="w-full">
              <input id="rfid-lock-attempt-final-input" matInput type="number" [formControlName]="'rfidLockAttemptFinal'" />
            </mat-form-field>
          </div>

          <div class="grid grid-cols-2 gap-5 items-center col-span-2">
            <p id="rfid-auto-write" class="pr-5">{{ translationService.translate('rfidAutomaticWriteText') }}</p>
            <mat-slide-toggle id="rfid-auto-write-switch" [formControlName]="'rfidAutoWrite'">
              {{ translationService.translate(plantSetupDetails.get('rfidAutoWrite').value ? 'yesText' : 'noText') }}
            </mat-slide-toggle>
          </div>
        </div>
        }
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="settings"></mic-icon>
            {{ translationService.translate('specificPostsForPlantText') }} {{ plantDetails?.code }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div formArrayName="plantPosts">
          <div class="flex flex-wrap items-center justify-between overflow-x-auto">
            <mic-status class="primary mt-4">{{ translationService.translate('postSettingsInheritedFromZoneSetupText') }}</mic-status>
            <mic-status class="primary mt-4">{{ translationService.translate('rRequiredYYesAvailableNNotAvailableText') }}</mic-status>
          </div>
          <div class="grid grid-cols-4 gap-1 items-center mt-2">
            @for (postGroup of plantPosts.controls; track $index; let i = $index) { @if (!isHiddenPost(postGroup.get('postName').value)) {
            <div [formGroupName]="i" class="grid grid-cols-2 items-center mt-2">
              <span class="w-full">{{ translationService.translate(getPostLabel(postGroup.get('postName').value)) }}</span>
              <mat-form-field appearance="fill" class="w-16 min-w-0">
                <mat-select formControlName="postActive">
                  @for (option of postDropdowns; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  } @if (!postDropdowns.includes(postGroup.get('postActive').value) && postGroup.get('postActive').value) {
                  <mat-option [value]="postGroup.get('postActive').value">
                    {{ postGroup.get('postActive').value }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            } }
          </div>
        </div>
        <div class="grid grid-cols-3 gap-5 items-center mt-4" [formGroup]="plantSetupDetails">
          <div class="grid grid-cols-3 gap-5 items-center">
            <p id="plant-shipping" class="pr-5 field-flag-label">
              {{ translationService.translate('shippingFlagText') }}<span class="required-marker">*</span>
            </p>
            <mat-radio-group formControlName="shipping" class="flex flex-row items-center gap-4">
              <mat-radio-button id="shipping-manual-radio-button" [checked]="plantSetupDetails.get('shipping').value === 'Y'" value="Y">
                {{ translationService.translate('manualText') }}
              </mat-radio-button>
              <mat-radio-button id="shipping-auto-radio-button" [checked]="plantSetupDetails.get('shipping').value === 'N'" value="N">
                {{ translationService.translate('autoText') }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="grid grid-cols-3 gap-5 items-center">
            <p id="plant-receiving" class="pr-5 field-flag-label">
              {{ translationService.translate('receivingFlagText') }}<span class="required-marker">*</span>
            </p>
            <mat-radio-group formControlName="receiving" class="flex flex-row items-center gap-4">
              <mat-radio-button id="receiving-manual-radio-button" [checked]="plantSetupDetails.get('receiving').value === 'Y'" value="Y">
                {{ translationService.translate('manualText') }}
              </mat-radio-button>
              <mat-radio-button id="receiving-auto-radio-button" [checked]="plantSetupDetails.get('receiving').value === 'N'" value="N">
                {{ translationService.translate('autoText') }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="settings"></mic-icon>
            {{ translationService.translate('specificProcessCodesForPlantText') }} {{ plantDetails?.code }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="flex flex-wrap items-center justify-between overflow-x-auto">
          <mic-status class="primary mt-4">{{ translationService.translate('postSettingsInheritedFromZoneSetupText') }}</mic-status>
          <mic-status class="primary mt-4">{{ translationService.translate('rRequiredYYesAvailableNNotAvailableText') }}</mic-status>
        </div>
        <div class="flex flex-col">
          <h3 class="section-subheading">
            {{ translationService.translate('processCodesWithSpecificWorkFlowsForPlantText') }} {{ plantDetails?.code }}
          </h3>
          <div class="flex flex-row items-center overflow-x-auto">
            <span class="w-32 pr-8 field-flag-label">{{ translationService.translate('casingProcessCodeText') }}</span>
            <div class="workflow-list ml-0 mr-10">
              @for (item of postNames; track item) {
              <div class="post-names">
                {{ item }}
              </div>
              }
            </div>
          </div>
          @if (!isDisabled('plantProcessCodes', 'RR')) {
          <div class="flex flex-row items-center overflow-x-auto">
            <div class="flex flex-row items-center pr-2">
              <span class="w-20 pr-2">RR - {{ translationService.translate('repairAndRetreadText') }}</span>
              <mat-form-field appearance="fill" class="w-14 min-w-0 mt-4">
                <mat-select [formControl]="getProcessCodeControl('RR', 'active')">
                  @for (option of postDropdowns; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  } @if (getProcessCodeControl('RR', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                  <mat-option [value]="'R'"> R </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div cdkDropList cdkDropListOrientation="horizontal" class="workflow-list ml-0" (cdkDropListDropped)="drop($event, 'RR')">
              @for (item of workflowItemsRR; track trackByIndex($index)) {
              <div class="workflow-box" cdkDrag>
                <span class="icon-dotted" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </span>
                {{ translationService.translate(getPostLabel(item)) }}
                <span class="icon-delete" (click)="onDeleteWorkflowItem($index, 'RR')">
                  <mat-icon color="warn">delete</mat-icon>
                </span>
              </div>
              }
            </div>
            <div class="flex-1"></div>
            <mat-form-field appearance="fill" class="w-32 pt-4" id="addPostField">
              <mat-label class="custom-label-error">{{ translationService.translate('addPostText') }}</mat-label>
              <mat-select subscriptSizing="dynamic" id="addPost" (selectionChange)="onAddPost($event.value, 'RR')">
                @for (postName of getWorkflowPostNames('RR'); track postName) {
                <mat-option [value]="postName">
                  {{ translationService.translate(getPostLabel(postName)) }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          } @if (!isDisabled('plantProcessCodes', 'RO')) {
          <div class="flex flex-row items-center overflow-x-auto">
            <div class="flex flex-row items-center pr-2">
              <span class="w-20 pr-2">RO - {{ translationService.translate('repairOnlyText') }}</span>
              <mat-form-field appearance="fill" class="w-14 min-w-0 mt-4">
                <mat-select [formControl]="getProcessCodeControl('RO', 'active')">
                  @for (option of postDropdowns; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  } @if (getProcessCodeControl('RO', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                  <mat-option [value]="'R'"> R </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div cdkDropList cdkDropListOrientation="horizontal" class="workflow-list" (cdkDropListDropped)="drop($event, 'RO')">
              @for (item of workflowItemsRO; track trackByIndex($index)) {
              <div class="workflow-box" cdkDrag>
                <span class="icon-dotted" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </span>
                {{ translationService.translate(getPostLabel(item)) }}
                <span class="icon-delete" (click)="onDeleteWorkflowItem($index, 'RO')">
                  <mat-icon color="warn">delete</mat-icon>
                </span>
              </div>
              }
            </div>
            <div class="flex-1"></div>
            <mat-form-field appearance="fill" class="w-32" id="addPostFieldRO">
              <mat-label class="custom-label-error">{{ translationService.translate('addPostText') }}</mat-label>
              <mat-select subscriptSizing="dynamic" id="addPostRO" (selectionChange)="onAddPost($event.value, 'RO')">
                @for (postName of getWorkflowPostNames('RO'); track postName) {
                <mat-option [value]="postName">
                  {{ translationService.translate(getPostLabel(postName)) }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          } @if (!isDisabled('plantProcessCodes', 'RS')) {
          <div class="flex flex-row items-center overflow-x-auto">
            <div class="flex flex-row items-center pr-2">
              <span class="w-20 pr-2">RS - {{ translationService.translate('reserveAndStockText') }}</span>
              <mat-form-field appearance="fill" class="w-14 min-w-0 mt-4">
                <mat-select [formControl]="getProcessCodeControl('RS', 'active')">
                  @for (option of postDropdowns; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  } @if (getProcessCodeControl('RS', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                  <mat-option [value]="'R'"> R </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div cdkDropList cdkDropListOrientation="horizontal" class="workflow-list" (cdkDropListDropped)="drop($event, 'RS')">
              @for (item of workflowItemsRS; track trackByIndex($index)) {
              <div class="workflow-box" cdkDrag>
                <span class="icon-dotted" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </span>
                {{ translationService.translate(getPostLabel(item)) }}
                <span class="icon-delete" (click)="onDeleteWorkflowItem($index, 'RS')">
                  <mat-icon color="warn">delete</mat-icon>
                </span>
              </div>
              }
            </div>
            <div class="flex-1"></div>
            <mat-form-field appearance="fill" class="w-32" id="addPostFieldRS">
              <mat-label class="custom-label-error">{{ translationService.translate('addPostText') }}</mat-label>
              <mat-select subscriptSizing="dynamic" id="addPostRS" (selectionChange)="onAddPost($event.value, 'RS')">
                @for (postName of getWorkflowPostNames('RS'); track postName) {
                <mat-option [value]="postName">
                  {{ translationService.translate(getPostLabel(postName)) }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          } @if (!isDisabled('plantProcessCodes', 'IO')) {
          <div class="flex flex-row items-center overflow-x-auto">
            <span class="w-20 pr-2">IO - {{ translationService.translate('inspectOnlyText') }}</span>
            <mat-form-field appearance="fill" class="w-14 min-w-0 mt-4 pr-2">
              <mat-select [formControl]="getProcessCodeControl('IO', 'active')">
                @for (option of postDropdowns; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
                } @if (getProcessCodeControl('IO', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                <mat-option [value]="'R'"> R </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="centered-box">
              {{ translationService.translate('initialInspectionText') }}
            </div>
          </div>
          } @if (!isDisabled('plantProcessCodes', 'SO')) {
          <div class="flex flex-row items-center overflow-x-auto">
            <span class="w-20 pr-2">SO - {{ translationService.translate('serviceOnlyText') }}</span>
            <mat-form-field appearance="fill" class="w-14 min-w-0 mt-4 pr-2">
              <mat-select [formControl]="getProcessCodeControl('SO', 'active')">
                @for (option of postDropdowns; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
                } @if (getProcessCodeControl('SO', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                <mat-option [value]="'R'"> R </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="centered-box">
              {{ translationService.translate('initialInspectionText') }}
            </div>
          </div>
          } @if (!isDisabled('plantProcessCodes', 'AD')) {
          <div class="flex flex-row items-center overflow-x-auto">
            <span class="w-20 pr-2">AD - {{ translationService.translate('adjustmentText') }}</span>
            <mat-form-field appearance="fill" class="w-14 min-w-0 mt-4 pr-2">
              <mat-select [formControl]="getProcessCodeControl('AD', 'active')">
                @for (option of postDropdowns; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
                } @if (getProcessCodeControl('AD', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                <mat-option [value]="'R'"> R </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="centered-box">
              {{ translationService.translate('adjustmentText') }}
            </div>
          </div>
          }
          <h3 class="section-subheading">
            {{ translationService.translate('allOtherProcessCodesThatApplyToPlantText') }} {{ plantDetails?.code }}
          </h3>
          <div class="grid grid-cols-6 mt-4">
            @if (!isDisabled('plantProcessCodes', 'BS')) {
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-2">BS - {{ translationService.translate('buildForStockText') }}</span>
              <mat-form-field appearance="fill" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('BS', 'active')">
                  @for (option of postDropdowns; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  } @if (getProcessCodeControl('BS', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                  <mat-option [value]="'R'"> R </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            } @if (!isDisabled('plantProcessCodes', 'CC')) {
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-3">CC - {{ translationService.translate('casingCreditText') }}</span>
              <mat-form-field appearance="fill" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('CC', 'active')">
                  @for (option of postDropdowns; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  } @if (getProcessCodeControl('CC', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                  <mat-option [value]="'R'"> R </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            } @if (!isDisabled('plantProcessCodes', 'CP')) {
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-2">CP - {{ translationService.translate('casingPurchaseText') }}</span>
              <mat-form-field appearance="fill" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('CP', 'active')">
                  @for (option of postDropdowns; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  } @if (getProcessCodeControl('CP', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                  <mat-option [value]="'R'"> R </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            } @if (!isDisabled('plantProcessCodes', 'DS')) {
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-3">DS - {{ translationService.translate('dealerStockText') }}</span>
              <mat-form-field appearance="fill" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('DS', 'active')">
                  @for (option of postDropdowns; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  } @if (getProcessCodeControl('DS', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                  <mat-option [value]="'R'"> R </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            } @if (!isDisabled('plantProcessCodes', 'SC')) {
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-3 pl-4">SC - {{ translationService.translate('scrapText') }}</span>
              <mat-form-field appearance="fill" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('SC', 'active')">
                  @for (option of postDropdowns; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  } @if (getProcessCodeControl('SC', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                  <mat-option [value]="'R'"> R </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            } @if (!isDisabled('plantProcessCodes', 'NP')) {
            <div class="grid grid-cols-2 gap-2">
              <span class="w-22 pt-3">NP - {{ translationService.translate('noPickupText') }}</span>
              <mat-form-field appearance="fill" class="w-14">
                <mat-select [formControl]="getProcessCodeControl('NP', 'active')">
                  @for (option of postDropdowns; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  } @if (getProcessCodeControl('NP', 'active')?.value === 'R' && !postDropdowns.includes('R')) {
                  <mat-option [value]="'R'"> R </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            }
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    @if (!isCreateMode) {
    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="settings"></mic-icon>
            {{ translationService.translate('tdmsPropertiesText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div class="button-container cam-table mt-2 ml-2 tdms-action-bar">
          <button id="add-button" type="button" mat-flat-button color="primary" (click)="onAddNewRule()">
            <mat-icon>add</mat-icon> {{ translationService.translate('addText') }}
          </button>
        </div>

        @if (tdmsPropertiesReady) {
        <div class="table mt-2 ml-2">
          <mic-table
            class="table-stripped"
            [uniqueKey]="'tdmsId'"
            [config]="tableConfig"
            [dataSource]="tdmsProperties"
            editType="row"
            #tableRef
            (rowChanged)="rowValueChanged($event)"
          >
            <!-- No data slot -->
            <ng-container *micTableNoData>
              <mic-empty-state icon="layers_clear" title="{{ translationService.translate('noTdmsPropertiesText') }}">
              </mic-empty-state> </ng-container
            ><ng-container *micCellTemplate="let item; name: 'action'">
              <span class="tdms-row-actions">
                <button
                  mat-icon-button
                  type="button"
                  class="btn-delete"
                  (click)="showDeleteModal(item)"
                  [attr.aria-label]="translationService.translate('deleteText')"
                >
                  <mic-icon class="m" icon="delete" fontSet="filled"></mic-icon>
                </button>
              </span>
            </ng-container>
          </mic-table>
        </div>
        }
      </mat-expansion-panel>
    </mat-accordion>
    }
  </form>
  }

  <mic-modal class="modalC" #deleteConfirmation (result)="onDeleteModalClosed($event)"></mic-modal>
  <ng-template #deleteContent>Are you sure you want to delete the TDMS Setting?</ng-template>
  <!-- Unsaved Changes Modal -->
  <ng-template #unsavedConfirmation>{{ translationService.translate('unSaveChangesText') }}</ng-template>
  <mic-modal class="modalC" #unsavedChangesModal></mic-modal>

  <!-- Loading Overlay -->
  @if (isLoading) {
  <div class="loading-overlay">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
  }
</div>
